exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframe[data-v-135035f3] {\n  border-radius: 4px;\n  background-color: #2a2a2a;\n  color: lightgray;\n  border: 1px gray solid;\n  padding: 8px;\n}\n", ""]);

// exports
